// extracted by mini-css-extract-plugin
export default {"submitBtn":"_3jQRU92LKU3-TqqsL4A5xI"};